module.exports = __webpack_public_path__ + "img/image52.26c8431d.png";